import { useInsiderFAQContentsAUS } from "@faire/retailer-visitor-shared/components/InsiderFAQContents/__internal__/useInsiderFAQContentsAUS";
import { useInsiderFAQContentsCAN } from "@faire/retailer-visitor-shared/components/InsiderFAQContents/__internal__/useInsiderFAQContentsCAN";
import { useInsiderFAQContentsEUR } from "@faire/retailer-visitor-shared/components/InsiderFAQContents/__internal__/useInsiderFAQContentsEUR";
import { useInsiderFAQContentsUSA } from "@faire/retailer-visitor-shared/components/InsiderFAQContents/__internal__/useInsiderFAQContentsUSA";
import { useNationality } from "@faire/retailer-visitor-shared/hooks/retailer/useNationality";
export var useInsiderFAQContents = function() {
    var usaFAQ = useInsiderFAQContentsUSA();
    var eurFAQ = useInsiderFAQContentsEUR();
    var canFAQ = useInsiderFAQContentsCAN();
    var ausFAQ = useInsiderFAQContentsAUS();
    var _useNationality = useNationality(), isAmerican = _useNationality.isAmerican, isEurope = _useNationality.isEurope, isCanadian = _useNationality.isCanadian, isAustralian = _useNationality.isAustralian;
    if (isAmerican) {
        return usaFAQ;
    }
    if (isEurope) {
        return eurFAQ;
    }
    if (isCanadian) {
        return canFAQ;
    }
    if (isAustralian) {
        return ausFAQ;
    }
    return [];
};
